import { expertWorkspaceWebSocketEventBus } from "@expert/websocket";
import { useQueryClient } from "@tanstack/react-query";
import { useEffect } from "react";
import type { ChallengeInfo } from "@/sales-tools/challenges/api/getChallenge";
import { upsertChallengeIfFresh } from "@/sales-tools/challenges/utils/upsertChallengeIfFresh";
import { usePartner } from "@/sdk";

export const useChallengeEventListener = () => {
    const queryClient = useQueryClient();
    const partner = usePartner();
    useEffect(() => {
        const subscription = expertWorkspaceWebSocketEventBus.on("ws_challenge-event", (payload: ChallengeInfo) => {
            const currentChallenges = queryClient.getQueryData<ChallengeInfo[]>(["get-challenge"]);
            void queryClient.setQueryData(
                ["get-challenge", partner],
                upsertChallengeIfFresh(payload, currentChallenges),
            );
        });

        return () => {
            subscription();
        };
    }, [queryClient, partner]);
};
